import { Component, Input } from '@angular/core';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent } from 'primeng/accordion';
import { FAQ } from '../../models/Faq';


@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [
    Accordion, AccordionPanel, AccordionHeader, AccordionContent
  ],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent{
  @Input()
  FAQs: Array<FAQ>;
  constructor() { }

}
